import React from "react";
import "./Terms.css";

const PrivacyPolicy = () => {
  return (
    <section className="legal-container">
      <div className="legal-wrapper">
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-date">Last Updated: January 2026</p>

        <p>
          Welcome to <strong>Teckpik</strong>. Your privacy is important to us.
          This policy explains how we collect, use, and protect your
          information.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>Personal information (name, email, phone, company name)</li>
          <li>
            Usage data such as IP address, browser type, and pages visited
          </li>
          <li>Communication data shared via forms or email</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To provide and improve our services</li>
          <li>To respond to inquiries and support requests</li>
          <li>To improve website performance and security</li>
        </ul>

        <h2>3. Cookies</h2>
        <p>
          We may use cookies to enhance user experience and analyze traffic. You
          can disable cookies through your browser settings.
        </p>

        <h2>4. Data Sharing</h2>
        <p>
          We do not sell or rent personal data. Information is shared only when
          legally required or necessary to operate our services.
        </p>

        <h2>5. Data Security</h2>
        <p>
          We implement reasonable safeguards, but no internet transmission is
          completely secure.
        </p>

        <h2>6. Your Rights</h2>
        <p>
          You may request access, correction, or deletion of your data by
          contacting us at <strong>info@teckpik.com</strong>.
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
